import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import ImageProject from 'components/atoms/imageProject';

import './style.css';

const ProjectLink = ({ title, client, slug, imageUrl, imageAlt }) => {
    return (
        <NavLink
            className="ProjectLink"
            activeClassName="ProjectLink__active"
            to={`/project/${slug}`}
        >
            <div className="ProjectLink__image">
                <ImageProject url={imageUrl} title={imageAlt} />
            </div>
            <div className="ProjectLink__text">
                <span className="ProjectLink__text__title">{title}</span>
                <span className="ProjectLink__text__seperator">/</span>
                <span className="ProjectLink__text__client">{client}</span>
            </div>
        </NavLink>
    );
};

ProjectLink.propTypes = {
    title: PropTypes.string,
    client: PropTypes.string,
    slug: PropTypes.string,
    imageUrl: PropTypes.string,
    imageAlt: PropTypes.string
};

ProjectLink.defaultProps = {
    title: 'Project title',
    client: 'Client name',
    slug: 'url-slug',
    url: 'https://picsum.photos',
    imageAlt: 'Image title'
};

export default ProjectLink;



// WEBPACK FOOTER //
// ./src/components/molecules/projectLink/index.js